/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectSpecificBillingInfoResource
 */
export interface ProjectSpecificBillingInfoResource {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectSpecificBillingInfoResource
     */
    projectBillingContacts: Array<string>;
}

/**
 * Check if a given object implements the ProjectSpecificBillingInfoResource interface.
 */
export function instanceOfProjectSpecificBillingInfoResource(value: object): value is ProjectSpecificBillingInfoResource {
    if (!('projectBillingContacts' in value) || value['projectBillingContacts'] === undefined) return false;
    return true;
}

export function ProjectSpecificBillingInfoResourceFromJSON(json: any): ProjectSpecificBillingInfoResource {
    return ProjectSpecificBillingInfoResourceFromJSONTyped(json, false);
}

export function ProjectSpecificBillingInfoResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectSpecificBillingInfoResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectBillingContacts': json['projectBillingContacts'],
    };
}

export function ProjectSpecificBillingInfoResourceToJSON(value?: ProjectSpecificBillingInfoResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectBillingContacts': value['projectBillingContacts'],
    };
}

